import { axios } from '@Root/API'

export const get = params => {
	return axios.get('help-text-page/get-field', { params })
}
